import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { type cbhFeatureFlags } from "@src/appV2/FeatureFlags/CbhFeatureFlags";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";
import { type z } from "zod";

type ScormCourseConfigMap = z.infer<
  (typeof cbhFeatureFlags)[typeof CbhFeatureFlag.SCORM_COURSE_CONFIG]
>;
type ScormCourseConfigEntry = ScormCourseConfigMap[string];

interface UseGetScormCourseConfigReturn {
  getScormConfig: (requirementId: string) => ScormCourseConfigEntry | undefined;
}

export function useGetScormCourseConfig(): UseGetScormCourseConfigReturn {
  const scormCourseConfig = useCbhFlag(CbhFeatureFlag.SCORM_COURSE_CONFIG, {
    defaultValue: {},
  });

  return {
    getScormConfig: (requirementId: string) => scormCourseConfig[requirementId],
  };
}
